import { render } from "./BagasseProducts.vue?vue&type=template&id=7e812aa8"
import script from "./BagasseProducts.vue?vue&type=script&lang=js"
export * from "./BagasseProducts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/utmtco-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__